import {ProcessHook, ProcessHookProps, ProcessHookRunProps} from "./process-hooks";
import {JsonObject} from "typescript-json-serializer";

/**
 * Hook to set project status to closed
 */
@JsonObject()
export class CloseProjectHook extends ProcessHook {

    class = "CloseProjectHook";
    constructor(props?: ProcessHookProps) { super(props); }

    run(runProps: ProcessHookRunProps): Promise<any> {
        return new Promise((resolve, reject) => {
            const {project} = runProps;

            if (project.statusId && project.statusId > 1) {
                reject("Project already closed.");
                return;
            }

            this.setStateToClosed(runProps).then(() => {
                resolve("Projekt geschlossen.");
            });
        });
    }

    private setStateToClosed(runProps: ProcessHookRunProps): Promise<void> {
        return new Promise((resolve) => {
            const {project, auftragsverwaltung, appStore} = runProps;

            // set project status to closed
            const updated = {
                statusId: 2
            };

            const user = appStore.esriCredential?.userId || "";
            const type = appStore.topic?.id === "projectsGk" ? "gefahrenkarte" : "risikoübersicht";
            auftragsverwaltung.ProjectStore?.save(project, type, updated, user).then(() => {
                resolve();
            });
        });
    }
}
